import React, { useEffect, useRef, useState } from "react";
import { HiX } from "react-icons/hi";
import { GrDownload } from "react-icons/gr";

const NewHeader = () => {
  const headerRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [isSticky, setIsSticky] = useState(false);
  const [animateClose, setAnimateClose] = useState(false);
  const [isBlocked, setIsBlocked] = useState(false);

  useEffect(() => {
    const header = headerRef.current;
    if (!header) return;

    const stickPoint = header.offsetTop;

    const handleScroll = () => {
      const offset = window.scrollY;
      setIsSticky(offset >= stickPoint);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const checkPosition = () => {
      const rect = headerRef.current.getBoundingClientRect();
      const threshold = window.innerHeight * 0.2;

      if (rect.top > threshold) {
        if (open) {
          handleClose();
        } else {
          setIsBlocked(true);
        }
      } else {
        setIsBlocked(false);
      }
    };

    window.addEventListener("scroll", checkPosition, { passive: true });
    checkPosition();
    return () => window.removeEventListener("scroll", checkPosition);
  }, [open]);

  const handleClose = () => {
    setAnimateClose(true);
    setTimeout(() => {
      setOpen(false);
      setAnimateClose(false);
    }, 450);
  };

  return (
    <header
      ref={headerRef}
      className={`transition-all duration-300 
        ${
          isSticky
            ? open
              ? "fixed top-0 left-0 w-full z-[60] bg-[#f5f2f0] sm:bg-transparent sm:bg-gradient-to-l sm:from-[#f5f2f0] sm:via-[#f5f2f0]/80 sm:to-transparent sm:backdrop-blur-0"
              : "fixed top-0 left-0 w-full z-[60] bg-transparent"
            : "relative bg-[#f5f2f0]"
        }
        h-20 flex items-center
      `}
    >
      <div className="flex justify-between items-center w-full px-10 lg:px-20">
        <a href="/HomePage">
          <img src="../assets/Logo2.png" alt="Logo" className="h-12" />
        </a>

        <div className="hidden lg:block ml-auto absolute right-40 top-7">
          <a href="/BookNow" onClick={handleClose}>
            <div
              className="text-[15px] text-[#4F423B] tracking-[0.3em] transform translate-y-20 opacity-0 animate-slideUp underline underline-offset-4"
              style={{ animationDelay: "0.45s" }}
            >
              Reserve Now!
            </div>
          </a>
        </div>

        {!open ? (
          <button
            onClick={() => !isBlocked && setOpen(true)}
            className="flex flex-col space-y-2.5 absolute right-10 lg:right-20 top-6 opacity-100 pointer-events-auto"
          >
            <span className="w-8 h-[2px] bg-[#948A78]"></span>
            <span className="w-8 h-[2px] bg-[#948A78]"></span>
            <span className="w-8 h-[2px] bg-[#948A78]"></span>
          </button>
        ) : (
          <button
            onClick={handleClose}
            className="text-3xl text-[#948A78] absolute right-8 sm:right-10 lg:right-20 top-6 z-[70]"
          >
            <HiX />
          </button>
        )}
      </div>

      {(open || animateClose) && (
        <>
          <div
            onClick={handleClose}
            className={`fixed left-0 top-20 h-[calc(100vh-80px)] w-full
            transition-opacity duration-500 z-[49]
            ${
              animateClose
                ? "opacity-0 pointer-events-none"
                : "opacity-100 pointer-events-auto"
            }`}
          ></div>

          <div
            className={`fixed top-20 right-0 h-[calc(100vh-80px)]
              bg-[#f5f2f0] sm:bg-transparent sm:bg-gradient-to-l sm:from-[#f5f2f0] sm:via-[#f5f2f0]/80 sm:to-transparent
              w-full px-10 py-16 flex flex-col justify-between text-left
              overflow-hidden z-[50]
              ${
                animateClose
                  ? "animate-menuSlideLeftToRight"
                  : "animate-menuSlideRightToLeft"
              }`}
          >
            <div className="flex justify-end w-full">
              <nav className="flex flex-col text-left text-xl tracking-[0.3em] text-[#948A78] space-y-8 sm:mr-5 lg:mt-5 -mt-8">
                {["Our Philosophy", "Our Spaces", "Our Services"].map(
                  (item, index) => (
                    <a
                      key={index}
                      href={`/${item.replace(/\s/g, "")}`}
                      onClick={handleClose}
                      className="transform translate-y-20 opacity-0 animate-slideUp"
                      style={{ animationDelay: `${index * 0.25}s` }}
                    >
                      {item}
                    </a>
                  )
                )}

                <div
                  className="flex items-center space-x-2 transform translate-y-20 opacity-0 animate-slideUp cursor-pointer"
                  style={{ animationDelay: "0.8s" }}
                >
                  <a
                    href="../assets/House_of_Tao.pdf"
                    target="_blank"
                    onClick={handleClose}
                    className="text-[#948A78] text-xl tracking-[0.3em] flex items-center xl:mt-60 lg:mt-44 lg:ml-3"
                  >
                    <GrDownload className="mr-3" /> Brochure
                  </a>
                </div>
              </nav>
            </div>

            <div className="flex justify-center mt-10 lg:hidden">
              <a
                href="/BookNow"
                onClick={handleClose}
                className="text-xl text-[#4F423B] tracking-[0.3em] transform translate-y-20 opacity-0 animate-slideUp sm:ml-[70vh] ml-7 underline underline-offset-4"
                style={{ animationDelay: "0.85s" }}
              >
                Reserve Now!
              </a>
            </div>
          </div>
        </>
      )}

      <style jsx>{`
        @keyframes slideUp {
          0% {
            opacity: 0;
            transform: translateY(50px);
          }
          100% {
            opacity: 1;
            transform: translateY(0);
          }
        }
        .animate-slideUp {
          animation: slideUp 0.85s forwards;
        }
        @keyframes menuSlideRightToLeft {
          0% {
            transform: translateX(100%);
          }
          100% {
            transform: translateX(0);
          }
        }
        .animate-menuSlideRightToLeft {
          animation: menuSlideRightToLeft 0.55s ease forwards;
        }
        @keyframes menuSlideLeftToRight {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(100%);
          }
        }
        .animate-menuSlideLeftToRight {
          animation: menuSlideLeftToRight 0.55s ease forwards;
        }
      `}</style>
    </header>
  );
};

export default NewHeader;

// import React, { useEffect, useRef, useState } from "react";
// import { HiX } from "react-icons/hi";

// const NewHeader = () => {
//   const headerRef = useRef(null);
//   const [open, setOpen] = useState(false);
//   const [isSticky, setIsSticky] = useState(false);
//   const [animateClose, setAnimateClose] = useState(false);
//   const [isBlocked, setIsBlocked] = useState(false);

//   useEffect(() => {
//     const header = headerRef.current;
//     if (!header) return;

//     const stickPoint = header.offsetTop;

//     const handleScroll = () => {
//       const offset = window.scrollY;
//       setIsSticky(offset >= stickPoint);
//     };

//     window.addEventListener("scroll", handleScroll, { passive: true });
//     return () => window.removeEventListener("scroll", handleScroll);
//   }, []);

//   useEffect(() => {
//     const checkPosition = () => {
//       const rect = headerRef.current.getBoundingClientRect();
//       const threshold = window.innerHeight * 0.2;

//       if (rect.top > threshold) {
//         if (open) {
//           handleClose();
//         } else {
//           setIsBlocked(true);
//         }
//       } else {
//         setIsBlocked(false);
//       }
//     };

//     window.addEventListener("scroll", checkPosition, { passive: true });
//     checkPosition();
//     return () => window.removeEventListener("scroll", checkPosition);
//   }, [open]);

//   const handleClose = () => {
//     setAnimateClose(true);
//     setTimeout(() => {
//       setOpen(false);
//       setAnimateClose(false);
//     }, 450);
//   };

//   return (
//     <header
//       ref={headerRef}
//       className={`transition-all duration-300
//         ${
//           isSticky
//             ? open
//               ? "fixed top-0 left-0 w-full z-[60] bg-[#f5f2f0] sm:bg-transparent sm:bg-gradient-to-l sm:from-[#f5f2f0] sm:via-[#f5f2f0]/80 sm:to-transparent sm:backdrop-blur-0"
//               : "fixed top-0 left-0 w-full z-[60] bg-transparent"
//             : "relative bg-[#f5f2f0]"
//         }
//         h-20 flex items-center
//       `}
//     >
//       <div className="flex justify-between items-center w-full px-10 lg:px-20">
//         <a href="/HomePage">
//           <img src="../assets/Logo2.png" alt="Logo" className="h-12" />
//         </a>

//         <div className="hidden lg:block ml-auto absolute right-40 top-7">
//           <a href="/BookNow" onClick={handleClose}>
//             <div
//               className="text-[15px] text-[#4F423B] tracking-[0.3em] transform translate-y-20 opacity-0 animate-slideUp"
//               style={{ animationDelay: "0.45s" }}
//             >
//               Book Now!
//             </div>
//           </a>
//         </div>

//         {!open ? (
//           <button
//             onClick={() => !isBlocked && setOpen(true)}
//             className="flex flex-col space-y-2.5 absolute right-10 lg:right-20 top-6 opacity-100 pointer-events-auto"
//           >
//             <span className="w-8 h-[2px] bg-[#948A78]"></span>
//             <span className="w-8 h-[2px] bg-[#948A78]"></span>
//             <span className="w-8 h-[2px] bg-[#948A78]"></span>
//           </button>
//         ) : (
//           <button
//             onClick={handleClose}
//             className="text-3xl text-[#948A78] absolute right-8 sm:right-10 lg:right-20 top-6 z-[70]"
//           >
//             <HiX />
//           </button>
//         )}
//       </div>

//       {(open || animateClose) && (
//         <>
//           <div
//             onClick={handleClose}
//             className={`fixed left-0 top-20 h-[calc(100vh-80px)] w-full
//             transition-opacity duration-500 z-[49]
//             ${
//               animateClose
//                 ? "opacity-0 pointer-events-none"
//                 : "opacity-100 pointer-events-auto"
//             }`}
//           ></div>

//           <div
//             className={`fixed top-20 right-0 h-[calc(100vh-80px)]
//               bg-[#f5f2f0] sm:bg-transparent sm:bg-gradient-to-l sm:from-[#f5f2f0] sm:via-[#f5f2f0]/80 sm:to-transparent
//               w-full px-10 py-16 flex flex-col justify-between text-left
//               overflow-hidden z-[50]
//               ${
//                 animateClose
//                   ? "animate-menuSlideLeftToRight"
//                   : "animate-menuSlideRightToLeft"
//               }`}
//           >
//             <div className="flex justify-end w-full">
//               <nav className="flex flex-col text-left text-xl tracking-[0.3em] text-[#948A78] space-y-8 sm:mr-5 mt-5">
//                 {["Our Philosophy", "Our Spaces", "Our Services"].map(
//                   (item, index) => (
//                     <a
//                       key={index}
//                       href={`/${item.replace(/\s/g, "")}`}
//                       onClick={handleClose}
//                       className="transform translate-y-20 opacity-0 animate-slideUp"
//                       style={{ animationDelay: `${index * 0.25}s` }}
//                     >
//                       {item}
//                     </a>
//                   )
//                 )}
//               </nav>
//             </div>

//             <div className="flex justify-center mt-10 lg:hidden">
//               <a
//                 href="/BookNow"
//                 onClick={handleClose}
//                 className="text-xl text-[#4F423B] tracking-[0.3em] transform translate-y-20 opacity-0 animate-slideUp sm:ml-[70vh] ml-7"
//                 style={{ animationDelay: "0.85s" }}
//               >
//                 Book Now!
//               </a>
//             </div>
//           </div>
//         </>
//       )}

//       <style jsx>{`
//         @keyframes slideUp {
//           0% {
//             opacity: 0;
//             transform: translateY(50px);
//           }
//           100% {
//             opacity: 1;
//             transform: translateY(0);
//           }
//         }
//         .animate-slideUp {
//           animation: slideUp 0.85s forwards;
//         }
//         @keyframes menuSlideRightToLeft {
//           0% {
//             transform: translateX(100%);
//           }
//           100% {
//             transform: translateX(0);
//           }
//         }
//         .animate-menuSlideRightToLeft {
//           animation: menuSlideRightToLeft 0.55s ease forwards;
//         }
//         @keyframes menuSlideLeftToRight {
//           0% {
//             transform: translateX(0);
//           }
//           100% {
//             transform: translateX(100%);
//           }
//         }
//         .animate-menuSlideLeftToRight {
//           animation: menuSlideLeftToRight 0.55s ease forwards;
//         }
//       `}</style>
//     </header>
//   );
// };

// export default NewHeader;
